import {useSuspenseQuery} from "@apollo/client";
import {differenceInDays, parseISO} from "date-fns";
import {Link} from "react-router";

import Button from "@/components/button/Button.tsx";
import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {GQL_LAUNCHPAD_BAR} from "@/lib/queries/launchpad.ts";

export const LaunchpadActions = () => {
  const {data} = useSuspenseQuery<{
    settingsInfo: {
      free_trial_period: number;
    };
  }>(GQL_LAUNCHPAD_BAR);
  const {user} = useCurrentUserContext();
  if (!user || !user?.account.free_trial_expires_at) {
    return null;
  }

  const free_trial_period = data?.settingsInfo.free_trial_period;
  const free_trial_expires_at = user?.account.free_trial_expires_at;
  const freeTrialRemaining = differenceInDays(parseISO(free_trial_expires_at), new Date());
  const daysUsed = Math.max(0, free_trial_period - freeTrialRemaining);
  const title = `${daysUsed} day(s) left`;
  const percentUsed = Math.round((daysUsed / free_trial_period) * 100);
  return (
    <div className="d-flex w-100 m-0 align-items-center">
      <div className="text-center me-4" data-bs-toggle="tooltip" title={title}>
        <div className="text-muted mb-2 fs-7">Free Trial</div>
        <div
          className="progress"
          role="progressbar"
          aria-label={title}
          aria-valuenow={percentUsed}
          aria-valuemin={0}
          aria-valuemax={100}
          style={{height: "0.5rem", width: "8rem"}}
        >
          <div className="progress-bar progress-bar-striped" style={{width: `${percentUsed}%`}} />
        </div>
      </div>
      <div className="text-right">
        <Button as={Link} size={"large"} to="/billing/manage-subscription">
          Subscribe Now
        </Button>
      </div>
    </div>
  );
};
